<nav class="navs">
  <ul class="nav nav-underline nav-client-type" id="myTab" role="tablist">
    <li class="nav-item" role="presentation">
      <button class="nav-link active" id="resource-tab" data-bs-toggle="tab" data-bs-target="#resource" type="button" role="tab"
        aria-controls="resource" aria-selected="true">{{'SCHEDULE_BOOKING' | translate}}</button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link" id="projects-tab" data-bs-toggle="tab" data-bs-target="#projects" type="button" role="tab"
        aria-controls="projects" aria-selected="false">{{'APPOINTMENT_SCHEDULED' | translate}}</button>
    </li>
  </ul>
</nav>

<div class="tab-content" id="myTabContent">
  <div class="tab-pane fade show active" id="resource" role="tabpanel" aria-labelledby="resource-tab">
    <div *ngIf="getListingAppointments()">
      <app-timekit-bookings></app-timekit-bookings>
    </div>
  </div>

  <div class="tab-pane fade show active" id="projects" role="tabpanel" aria-labelledby="projects-tab">
    <div *ngIf="getListingCreateAppointment()">
      <app-timekit-reschedule></app-timekit-reschedule>
    </div>
  </div>
</div>
<app-footer></app-footer>
